export default "__VITE_ASSET__CIyhcR_2__"